import { cn } from '@/lib/utils';
import React from 'react';

export type StatusTone = 'success' | 'warning' | 'danger' | 'neutral';

const DOT_CLASSNAME: Record<StatusTone, string> = {
    success: 'bg-green-500',
    warning: 'bg-amber-500',
    danger: 'bg-red-500',
    neutral: 'bg-muted-foreground'
};

interface StatusBadgeProps {
    tone: StatusTone;
    children: React.ReactNode;
    className?: string;
}

export const StatusDot: React.FC<{ tone: StatusTone; className?: string }> = ({
    tone,
    className
}) => (
    <span
        aria-hidden
        className={cn('rounded-full size-2 shrink-0', DOT_CLASSNAME[tone], className)}
    />
);

export const StatusBadge: React.FC<StatusBadgeProps> = ({
    tone,
    children,
    className
}) => (
    <span
        className={cn(
            'inline-flex items-center gap-2 px-3 border border-border rounded-full h-7 text-(length:--fs-subtitle) leading-(--lh-subtitle) text-foreground whitespace-nowrap',
            className
        )}
    >
        <StatusDot tone={tone} />
        {children}
    </span>
);
